import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      height: '100%',
      flex: 1,
    },
    image: {
      width: 224,
      height: 224,
      borderRadius: 224,
      marginBottom: 24,
    },
    button: {
      width: 285,
      height: 46,
      marginTop: theme.spacing(5),
    },
  }),
);
